import script from "./HomePendingOrders.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomePendingOrders.vue?vue&type=script&setup=true&lang=ts"

import "./HomePendingOrders.vue?vue&type=style&index=0&id=29b08feb&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29b08feb"]])

export default __exports__